import {useCallback, useEffect, useState} from 'react'
import {useReducedMotion} from 'framer-motion'

const useVideoControl = (init, videoRef, {isFullVideo = false} = {}) => {
    const shouldReduceMotion = useReducedMotion()
    // Full video always waits for user interaction; animation/direct respect the CMS autoplay value
    const effectiveInit = isFullVideo ? false : init
    const [isPlaying, setIsPlaying] = useState(effectiveInit && !shouldReduceMotion)

    // Full video mode: one-way flag — stays true once video has started
    const [hasStartedPlaying, setHasStartedPlaying] = useState(false)

    useEffect(() => {
        setIsPlaying(effectiveInit && !shouldReduceMotion)
    }, [effectiveInit, shouldReduceMotion])

    const onVideoToggle = useCallback(() => {
        setIsPlaying((prev) => !prev)
    }, [])

    const onPlay = useCallback(() => {
        setHasStartedPlaying(true)
    }, [])

    const play = useCallback(
        (muteVideo) => {
            if (videoRef.current) {
                videoRef.current.play(muteVideo)
                setIsPlaying(true)
            }
        },
        [videoRef]
    )

    const pause = useCallback(() => {
        if (videoRef.current) {
            videoRef.current.pause()
            setIsPlaying(false)
        }
    }, [videoRef])

    useEffect(() => {
        if (!videoRef?.current) return
        if (isPlaying) {
            videoRef.current.play()
        } else {
            videoRef.current.pause()
        }
    }, [isPlaying, videoRef])

    const showPosterOverlay = isFullVideo && !hasStartedPlaying
    const overlay = {
        showDarken: !isFullVideo || showPosterOverlay,
        showAnimationControl: !isFullVideo,
        showPosterOverlay
    }

    return [isPlaying, onVideoToggle, {pause, play, hasStartedPlaying, onPlay, overlay}]
}

export default useVideoControl
